import React from "react";
import { Star, Users, Briefcase, Sparkles } from "lucide-react";
import Avatar from "@/components/Avatar";
import VehicleImage from "@/components/VehicleImage";
import Button from "@/components/Button";
import { money, cn } from "@/lib/format";

export default function BidCard({ offer, onAccept, loading, disabled, best = false }) {
  const d = offer.driver || {};
  const vDesc = `${d.color || ""} ${d.vehicle || ""}`.trim();
  return (
    <div
      className={cn(
        "relative rounded-2xl border bg-card p-4 shadow-soft animate-fade-up",
        best ? "border-green-500 best-card" : "border-border"
      )}
      data-testid={`bid-card-${offer.id}`}
    >
      {best && (
        <div className="pointer-events-none absolute -top-2.5 left-4 z-10 flex items-center gap-1 rounded-full best-badge px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-wide shadow-md" data-testid={`best-offer-${offer.id}`}>
          <Sparkles className="h-3.5 w-3.5 animate-sparkle" /> Best offer
        </div>
      )}
      <div className={cn("flex items-center gap-3", best && "mt-1.5")}>
        <Avatar src={d.photo} name={d.name} size={48} />
        <div className="min-w-0 flex-1">
          <p className="truncate font-bold text-foreground">{d.name}</p>
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <span className="flex items-center gap-0.5">
              <Star className="h-3.5 w-3.5 fill-amber-400 text-amber-400" /> {Number(d.rating || 5).toFixed(1)}
            </span>
            <span>·</span>
            <span className="truncate">{vDesc || "Vehicle"}</span>
          </div>
        </div>
        <VehicleImage desc={vDesc} className="h-12 w-20 rounded-lg" iconSize={22} testID={`offer-vehicle-${offer.id}`} />
      </div>
      <div className="mt-3 flex items-center justify-between">
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          {d.class_label && (
            <span className="rounded-full bg-accent px-2.5 py-1 font-semibold text-brand-700 dark:text-brand-400">{d.class_label}</span>
          )}
          {d.max_pax && (
            <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5" /> {d.max_pax}</span>
          )}
          {d.max_bags != null && (
            <span className="flex items-center gap-1"><Briefcase className="h-3.5 w-3.5" /> {d.max_bags}</span>
          )}
        </div>
        <div className="text-right">
          {best && <p className="text-[10px] font-bold uppercase tracking-wide text-green-600">Lowest fare</p>}
          <p className="font-num text-2xl font-bold leading-none text-foreground">{money(offer.fare)}</p>
        </div>
      </div>
      <Button
        className="mt-3 w-full"
        onClick={() => onAccept(offer)}
        loading={loading}
        disabled={disabled}
        data-testid={`accept-offer-${offer.id}`}
      >
        Choose {d.name?.split(" ")[0]} · {money(offer.fare)}
      </Button>
    </div>
  );
}
